<template>
  <div>
    <user-token-site-name :user-token="user_token" @updateSiteInfo="updateSiteInfo" />
    <div class="setting-wrap">
      <div class="wrap-title">ご利用プラン</div>
      
      <!-- サードパーティ利用プラン -->
      <div class="setting-plan-detail" v-if="userdata.thirdparty_app">
        <div class="setting-plan-detail-title">
          <div>現在ご利用中のプラン:</div>          
          <div v-if="permission">ご利用料金:</div>          
          <div>プランご利用開始日:</div>
        </div>
        <div class="setting-plan-detail-content">
          <div>{{ service_plan_name }}({{ userdata.thirdparty_app }}特別プラン)</div>
          <div>{{ service_plan_price }}円(税別)/月 ※料金はトライアル終了後から発生します</div>
          <div>{{ userdata.thirdparty_app }}のアプリ設定画面にてご確認ください</div>
        </div>
      </div>
            
      <!-- トライアルプラン -->
      <div class="setting-plan-detail" v-else-if="$can(activate, 'eqTrialPlan')">
        <div class="setting-plan-detail-title">
          <div>現在ご利用中のプラン:</div>
          <div>トライアル期限:</div>
        </div>
        <div class="setting-plan-detail-content">
          <div>{{ service_plan_name }}</div>
          <div>{{ userdata.trial_expiration_at | date }}</div>
        </div>
      </div>
      
      <!-- フリープラン -->
      <div class="setting-plan-detail" v-else-if="$can(activate, 'lteFreePlan')">
        <div class="setting-plan-detail-title">
          <div>現在ご利用中のプラン:</div>
        </div>
        <div class="setting-plan-detail-content">
          <div>{{ current_plan }}</div>
        </div>
      </div>
      
      <!-- 有料プラン -->
      <div class="setting-plan-detail" v-else>
        <div class="setting-plan-detail-title">
          <div>現在ご利用中のプラン:</div>                    
          <div v-if="userdata.price_display != 'none' && permission">ご利用料金:</div>
          <div>プランご利用開始日:</div>
          <div>契約終了日:</div>
        </div>
        <div class="setting-plan-detail-content">
          <!-- ご利用中のプラン -->
          <div>{{ service_plan_name }}{{ userdata.contract_period ? "(" + userdata.contract_period + "ヶ月契約)" : "" }}</div>
          <!-- ご利用料金 -->
          <div v-if="userdata.contract_price && userdata.price_display != 'none'">{{ userdata.contract_price | addComma }}円(税別)/月</div>
          <div v-else>-</div>
          <!-- プランご利用開始日 -->
          <div v-if="activate_at">{{ activate_at | date }}</div>
          <!-- 契約終了日 -->
          <div v-if="userdata.activate_expiration_at">{{ userdata.activate_expiration_at | date }} <span v-if="userdata.contract_period > 1">(期日を過ぎると自動更新されます)</span></div>
        </div>
      </div>      
    </div>  
    
    <div class="setting-wrap" v-if="permission">
      <div class="wrap-title">プランの契約・解約</div>
      
      
      <div class="setting-plan-wrap" v-if="!userdata.thirdparty_app">
        <div v-for="service_plan in show_service_plan_list" :key="service_plan.service_plan_id" class="setting-plan-card">
          <div class="setting-plan-card-plan" :class="service_plan.service_plan_name_en.toLowerCase()">
            <div>
              {{ service_plan.service_plan_name }}プラン
              <div class="setting-plan-current" v-if="service_plan.activate === activate"><font-awesome-icon icon="paper-plane" style="font-size:10px; margin-right:3px" />利用中のプラン</div>
            </div>
            <p style="font-size: 10px;">{{ service_plan.description }}</p>
          </div>
          <div class="setting-plan-card-box" :class="serviceEnabledClass(searchEnabled(service_plan))">
            <i :class="serviceLimitedIcon(searchAllEnabled(service_plan))" style="font-size:16px; margin-right:5px"></i>
            インフルエンサー検索
            <el-tooltip v-show="!searchAllEnabled(service_plan)">
              <div slot="content">Instagram以外は対象外</div>
              <font-awesome-icon icon="question-circle" style="margin-left:5px" />
            </el-tooltip>
          </div>
          <div class="setting-plan-card-box" :class="serviceEnabledClass(service_plan.view_influencer_list_enabled)" >
            <i :class="serviceLimitedIcon(service_plan.view_influencer_audience_enabled)" style="font-size:16px; margin-right:5px"></i>
            インフルエンサー分析
            <el-tooltip v-show="!service_plan.view_influencer_audience_enabled" >
              <div slot="content">フォロワー情報の男女比・年齢比での分析は対象外</div>
              <font-awesome-icon icon="question-circle" style="margin-left:5px" />
            </el-tooltip>
          </div>
          <div class="setting-plan-card-box" :class="serviceEnabledClass(service_plan.collect_stories_limit_num)">
            <i :class="serviceEnabledIcon(service_plan.collect_stories_limit_num)" style="font-size:16px; margin-right:5px"></i>
            Instagramストーリーズ収集
          </div>
          <div class="setting-plan-card-box" :class="serviceEnabledClass(service_plan.search_post_enabled)" >
            <i :class="serviceEnabledIcon(service_plan.search_post_enabled)" style="font-size:16px; margin-right:5px"></i>
            クリエイティブ検索
          </div>
          <div class="setting-plan-card-box" :class="serviceEnabledClass(service_plan.create_influencer_list_limit_num)">
            <i :class="serviceLimitedIcon(!createListLimited(service_plan))" style="font-size:16px; margin-right:5px"></i> 
            インフルエンサーリスト <span v-show="createListLimited(service_plan)">(上限{{ service_plan.create_influencer_list_limit_num }}件)</span>
          </div>
          <div class="setting-plan-card-box" :class="serviceEnabledClass(service_plan.create_report_limit_num)">
            <i :class="serviceLimitedIcon(!createReportLimited(service_plan))" style="font-size:16px; margin-right:5px"></i>
            レポート作成 <span v-show="createReportLimited(service_plan)">(上限{{ service_plan.create_report_limit_num }}件)</span>
          </div>
          <div class="setting-plan-card-box" :class="serviceEnabledClass(service_plan.export_influencer_list_enabled)">
            <i :class="serviceEnabledIcon(service_plan.export_influencer_list_enabled)" style="font-size:16px; margin-right:5px"></i>
            リスト・レポートエクスポート
          </div>
          <div class="setting-plan-card-box" :class="serviceEnabledClass(service_plan.connect_ig_account_limit_num)">
            <i :class="serviceEnabledIcon(service_plan.connect_ig_account_limit_num)" style="font-size:16px; margin-right:5px"></i> 
            ダイレクトメッセージ
            <el-tooltip v-show="service_plan.connect_ig_account_limit_num">
              <div slot="content">アカウント連携上限：{{ service_plan.connect_ig_account_limit_num }}アカウント</div>
              <font-awesome-icon icon="question-circle" style="margin-left:5px" />
            </el-tooltip>
          </div>
          <div class="setting-plan-card-box blue">
            <i :class="serviceLimitedIcon(service_plan.multi_access_enabled)" style="font-size:16px; margin-right:5px"></i> 
            アクセス: <span v-if="service_plan.multi_access_enabled" >無制限</span><span v-else >1ユーザーのみ</span>
            <el-tooltip>
              <div slot="content" v-if="service_plan.multi_access_enabled">同一部署間でのアカウントの共有可。無制限の同時アクセス</div>
              <div slot="content" v-else>アカウントの共有不可。1ユーザーのみしか同時アクセスできません。</div>
              <font-awesome-icon icon="question-circle" style="margin-left:5px" />
            </el-tooltip>
          </div>
          <div class="setting-plan-card-box" :class="serviceEnabledClass(service_plan.multi_access_enabled)">
            <i :class="serviceEnabledIcon(service_plan.multi_access_enabled)" style="font-size:16px; margin-right:5px"></i> 
            サブアカウント作成
          </div>
          <div class="setting-plan-card-box" :class="serviceEnabledClass(service_plan.manage_brand_enabled)">
            <i :class="serviceEnabledIcon(service_plan.manage_brand_enabled)" style="font-size:16px; margin-right:5px"></i> 
            メンバー・ブランド管理
          </div>          
          <div class="setting-plan-card-box" :class="serviceEnabledClass($can(service_plan.activate, 'eqEnterprisePlan'))" >
            <i :class="serviceOptionalIcon($can(service_plan.activate, 'gteProPlan'))" style="font-size:16px; margin-right:5px"></i> 
            追加機能リクエスト
            <el-tooltip v-show="$can(service_plan.activate, 'eqProPlan')">
              <div slot="content">原則不可</div>
              <font-awesome-icon icon="question-circle" style="margin-left:5px" />
            </el-tooltip>
            <el-tooltip v-show="$can(service_plan.activate, 'eqEnterprisePlan')">
              <div slot="content">可能な限り対応</div>
              <font-awesome-icon icon="question-circle" style="margin-left:5px" />
            </el-tooltip>
          </div>          
          <div v-show="!isOem" class="setting-plan-card-box blue">
            <i class="el-icon-check" style="font-size:16px; margin-right:5px"></i> 
            チャットサポート <span v-show="$can(service_plan.activate, 'eqEnterprisePlan')" >/電話サポート</span> 
          </div>
          
          <div class="setting-plan-card-button">
            <div>
              <router-link :to="{ path: '/setting/upgrade', query: { payment: service_plan.service_plan_name_en } }" v-if="($can(activate, 'eqTrialPlan') || $can(activate, 'lteFreePlan')) && update_token == '6UgWG7ejgXPaL4rF'">
                <el-button type="primary">今すぐプランをアップグレード</el-button>
              </router-link>
              <span v-else>-</span>
            </div>
          </div>
        </div>
                
      </div>

      <div class="setting-plan-wrap" v-if="$can(activate, 'paidPlan') && userdata.thirdparty_app">
        <div></div>
        <div class="setting-plan-cancell">
          <div>
            現在のプラン({{ service_plan_name }})の解約
            <br />
            <div class="setting-plan-cancell-alert">プランを解約するには、{{ userdata.thirdparty_app }}のアプリ設定画面にて当アプリをアンインストールしてください。</div>
          </div>
        </div>
        <div class="setting-plan-cancell" style="margin-top: 20px;" v-if="$can(activate, 'eqManagerPlan')">
          <div>
            プランのアップグレード
            <br />
            <div class="setting-plan-cancell-alert">
              プランをアップグレードするには、{{ userdata.thirdparty_app }}のアプリ設定画面にて当アプリをアンインストール後、プロプランを再度インストールしてください。
            </div>
          </div>
        </div>
      </div>
      <div class="setting-plan-wrap" v-else-if="$can(activate, 'paidPlan') && !isOem">
        <div></div>
        <div class="setting-plan-cancell">
          <div>
            現在のプランを変更・解約される場合は画面右下のチャットフォームの「メッセージを送信」よりお問い合わせお願い致します。
            <br />
            <div class="setting-plan-cancell-alert">プランを解約すると、契約期間が残っている場合でも現在のプランの機能は利用できなくなりますのでご注意ください</div>
          </div>
        </div>
        <!-- キャンセル用パラメータがある場合のみ表示 -->
        <el-button v-show="update_token == '6UgWG7ejgXPaL4rF'" @click="cancel_modal = true" type="danger">解約</el-button>
      </div>
    </div>
    
    
    <el-dialog title="現在のプランの解約" :visible.sync="cancel_modal" width="600px" v-if="$can(activate, 'paidPlan')" :close-on-click-modal="cancel_loading ? false : true">
      <div style="padding:0px 10px">
        <div style="margin-bottom:20px">プランの解約をご希望とのことで誠に残念です。今後のサービス向上のため、よろしければ理由をお聞かせください。</div>
        <div style="display:flex; flex-flow:column">
          <el-radio class="setting-cancel-reason" v-model="cancel_reason" label="1">一時的に必要なくなった</el-radio>
          <el-radio class="setting-cancel-reason" v-model="cancel_reason" label="2">他プランにアップグレード/ダウングレードするため</el-radio>
          <el-radio class="setting-cancel-reason" v-model="cancel_reason" label="3">他社サービスに切り替えるため</el-radio>
          <el-radio class="setting-cancel-reason" v-model="cancel_reason" label="4">価格が高いため</el-radio>
          <el-radio class="setting-cancel-reason" v-model="cancel_reason" label="5">機能に満足できない、または問題があるため</el-radio>
          <el-radio class="setting-cancel-reason" v-model="cancel_reason" label="9">その他(理由をご記入ください)</el-radio>
          <div v-if="cancel_reason == 9" style="margin-top:10px; font-size:11px">
            よろしければ解約の理由を詳しくお教えください
            <el-input type="textarea" :rows="4" placeholder="キャンセルの理由" v-model="cancel_reason_detail"></el-input>
          </div>
        </div>
        <div class="setting-cancel-alert">
          プランを解約すると、現在のプランの機能は直ちに利用できなくなります。また契約期間途中の解約の場合、プラン解約時に契約終了分までのご請求を一括で行わせていただきます。
        </div>
        <el-checkbox class="setting-upgrade-checkbox" v-model="cancel_confirm"
          >上記注意事項および
          <a :href=termsOfUseUrl target="_blank" style="color:#0095f6">利用規約</a>
          に同意してプランを解約します。</el-checkbox
        >
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancel_modal = false">解約をやめる</el-button>
        <el-button :disabled="!cancelConcent || cancel_loading" type="primary" @click="cancelCurrentPlan">
          <div class="flex-row">
            解約を続行
            <div class="loader--mini" v-show="cancel_loading"></div>
          </div>
        </el-button>
      </span>
    </el-dialog>
    
  </div>
</template>

<script>
import UserTokenSiteName from "@/components/oem/UserTokenSiteInfo.vue";
const root = process.env.VUE_APP_API;
const cancelAPI = root + "/api/upgrade/cancel";

export default {
  name: "plan",
  props: ["userdata"],
  components: {
    UserTokenSiteName,
  },
  provide() {
    return {
      updateSiteInfo: this.updateSiteInfo
    }
  },
  data() {
    return {
      cancel_loading: false,
      cancel_modal: false,
      cancel_reason: "",
      cancel_reason_detail: "",
      cancel_confirm: false,
      option_modal: false,
      option_confirm: false,
      pro_modal: false,
      pro_confirm: false,
      link: "",
      termsOfUseUrl: "https://reech.co.jp/term/",
      isOem: false,
    };
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    user_token() {
      return this.$store.state.user_token;
    },
    permission() {
      return this.$store.state.permission.company_setting.access;
    },
    activate() {
      return this.$store.state.activate;
    },
    activate_at() {
      return this.$store.state.activate_at;
    },
    trial_expiration_at() {
      return this.$store.state.trial_expiration_at;
    },
    service_plan_name() {
      return this.$store.state.service_plan.service_plan_name + "プラン";
    },
    service_plan_description() {
      return this.$store.state.service_plan.description;
    },
    show_service_plan_list() {
      return this.$store.state.service_plan_list.filter(e => { return e.show_plan_list === 1});
    },
    cancelConcent() {
      if (this.cancel_reason > 0 && this.cancel_confirm == true) {
        return true;
      } else {
        return false;
      }
    },
    update_token() {
      return this.$route.query.update;
    }
  },
  mounted() {
  },
  methods: {
    cancelCurrentPlan() {
      this.cancel_loading = true;
      var params = new URLSearchParams();
      params.append("token", this.token);
      params.append("cancel_reason", this.cancel_reason);
      params.append("cancel_reason_detail", this.cancel_reason_detail);
      this.axios.post(cancelAPI, params).then(() => {
        this.$store.dispatch("getUserData", { token: this.token, user_token: this.user_token });
        this.loadUserData();
        this.scrollTop();
        this.cancel_modal = false;
        this.$nextTick(() => {
          this.$message({
            type: "success",
            offset: 7,
            showClose: true,
            message: "現在のプランをキャンセルしました",
          });
          this.cancel_loading = false;
        });
      });
    },
    searchEnabled(service_plan) {
      if(
        service_plan.search_influencer_instagram_enabled || 
        service_plan.search_influencer_youtube_enabled ||
        service_plan.search_influencer_tiktok_enabled ||
        service_plan.search_influencer_x_enabled) return true;
      return false;
    },
    searchAllEnabled(service_plan) {
      if(
        service_plan.search_influencer_instagram_enabled && 
        service_plan.search_influencer_youtube_enabled &&
        service_plan.search_influencer_tiktok_enabled &&
        service_plan.search_influencer_x_enabled) return true;
      return false;
    },
    createListLimited(service_plan) {
      return service_plan.create_influencer_list_limit_num !== null ? true : false;
    },
    createReportLimited(service_plan) {
      return service_plan.create_report_limit_num !== null ? true : false;
    },
    serviceEnabledClass(enabled) {
      if (enabled === null) return 'blue';
      return enabled ? 'blue' : 'free';
    },
    serviceEnabledIcon(enabled) {
      return enabled ? 'el-icon-check' : 'el-icon-close';
    },
    serviceLimitedIcon(enabled) {
      return enabled ? 'el-icon-check' : 'el-icon-warning-outline';
    },
    serviceOptionalIcon(enabled) {
      return enabled ? 'el-icon-warning-outline' : 'el-icon-close';
    },
    updateSiteInfo({termsOfUseUrl, isOem}) {
      this.termsOfUseUrl = termsOfUseUrl;
      this.isOem = isOem;
    },
  },
  watch: {},
  filters: {
    addComma(val) {
      return Math.floor(val).toLocaleString();
    },
    date(val) {
      const datetime = String(val);
      const datetime_parse = datetime.replace(/-/g, "/");
      const date_after = datetime_parse.slice(0, -9);
      return date_after;
    },
    timestamp(val) {
      const timestamp = Date.parse(val);
      parseInt(timestamp);
      return timestamp;
    },
  },
};
</script>
